export default __webpack_public_path__ + "static/media/er.d647083a.svg";